/// <reference path="WebComponent.ts" />


namespace Sintra {

	// const WizardControlStyle = document.createElement("style");
	// WizardControlStyle.innerHTML = `
	// 	.wizard-control {
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: stretch;
	// 		align-items: stretch;
	// 		position: relative;
	// 	}
	// 	.wizard-control > .header-container {
	// 		/*background: red;*/
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: center;
	// 	}
	// 	.wizard-control > .content {
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: center;
	// 		align-items: center;
	// 	}
	// 	.page-container {
	// 		/*background: green;*/
	// 		margin-top: 20px;
	// 		padding: 5px;
	// 		flex-grow: 1;
	// 	}
	// 	.group-container {
	// 		padding: 0;
	// 		margin: 0;
	// 	}
	// 	.group-header {
	// 		list-style: none;
	// 		margin: 0;
	// 		display: inline-block;
	// 		padding: 5px;
	// 		cursor: pointer;
	// 	}
	// 	.group-header.active {
	// 		cursor: default;
	// 		font-weight: bold;
	// 	}
	// 	.navigate-history-button {
	// 		cursor: pointer;
	// 		user-select: none;
	// 	}
	// 	.back-button {
	// 		display: none;
	// 	}
	// 	.next-button {
	// 		display: none;
	// 	}
	// 	[template-part="resultDataView"] {
	// 		display: none;
	// 		padding: 5px;
	// 		border: 1px solid red;
	// 	}`;	
	//document.head.appendChild(WizardControlStyle);

	const WizardControlSplashTemplate = document.createElement("template");
	WizardControlSplashTemplate.innerHTML = /*html*/ `
		<div template-part="contentContainer" class="content-container"></div>
		<div template-part="buttonContainer" class="button-container"></div>
	`;

	const WizardControlTemplate = document.createElement("template");
	WizardControlTemplate.innerHTML = /*html*/ `
		<div template-part="splashContainer" class="splash-container"></div>
		<div template-part="headerContainer" class="header-container"></div>
		<div template-part="pageContainer" class="page-container"></div>
	`;

	export class WizardControl extends WebComponent {

		private _resultData: DynamicObject;
		private _wizardData: WizardData;

		private _history: NavigationHistory;
		private _wizardPages: {[name: string]: WizardPage};
		private _currentPage: WizardPage;
		private _groupHeaders: Array<WizardGroupHeader>;
		private _currentGroup: WizardGroupHeader;

		private _groupNamePaths: Array<Array<MapEntry<string, string>>>;
		private _currentGroupNamePath: Array<MapEntry<string, string>>;

		private _splashContainer: HTMLElement;
		private _headerContainer: HTMLElement;
		private _headerWrapper: HTMLElement;
		private _pageContainer: HTMLElement;

		private _pageTemplate: TemplateSource;
		private _splashTemplate: TemplateSource;
		private _groupHeaderTemplate: TemplateSource;
		private _navButtonTemplate: TemplateSource;

		private _splashButtonStart: WizardNavButton;

		constructor(templateSource?: TemplateSource) {
			super("div", templateSource || WizardControlTemplate);

			this._history = new NavigationHistory();
			this._history.addChangedHandler((history) => {
				console.log("history changed");
				console.log(history.currentItem);
			});

			this.splashTemplate = WizardControlSplashTemplate;
			this.htmlElement.classList.add("wizard-control");
		}

		protected onApplyTemplate(templateRoot: HTMLElement) {
			this._splashContainer = this.getTemplatePart("splashContainer");
			this._headerWrapper = this.getTemplatePart("headerWrapper");
			this._headerContainer = this.getTemplatePart("headerContainer");
			this._pageContainer = this.getTemplatePart("pageContainer");

			if (this._wizardData) {
				this._loadData();
			}
		}


		private _buildWizardHeader(pathGroups: Array<MapEntry<string, string>>) {
			this._groupHeaders.length = 0;
			this._headerContainer.innerHTML = "";
			let groupNumber = 1;
			for (const group of pathGroups) {
				const groupHeader = new WizardGroupHeader();
				groupHeader.target = group[1];
				groupHeader.groupNumber = groupNumber++;
				groupHeader.groupName = group[0];
				if (this._groupHeaderTemplate) {
					groupHeader.template = this._groupHeaderTemplate;
				}
				groupHeader.htmlElement.addEventListener("group-click", this._onGroupClick.bind(this));
				this._groupHeaders.push(groupHeader);
				this._headerContainer.appendChild(groupHeader.htmlElement);
			}
		}

		private _loadData() {
			this._wizardPages = {};
			this._groupHeaders = [];
			this._history.clear();
			this._resultData = {};
			this._resolvePaths();

			if (this._wizardData.startText) {
				this._showSplashPage();
			}
			else {
				this._resolveAndNavigate(
					this._wizardData.startPage,
					(pageKey, page) => {
						this._history.pushAndGoTo(pageKey);
					},
					(pageKey, page) => {
						this._updateGropuHeadersState(page.pageData);
					});
			}
		}

		private _fadeOutElement(element: HTMLElement, completedCallback: () => void) {

			// TEMPORARY
			const fadeOut = () => {
				setTimeout(() => {
						let opacity = element.style.opacity;
						if (opacity === "") {
							opacity = "1";
						}
						const v = parseFloat(opacity) - 0.1;
						if (v <= 0) {
							element.style.opacity = "0";
							completedCallback();
						}
						else {
							element.style.opacity = `${v}`;
							fadeOut();
						}
					},
					25);
			};

			fadeOut();
		}

		private _fadeInElement(element: HTMLElement, completedCallback: () => void) {

			// TEMPORARY
			const fadeIn = () => {
				setTimeout(() => {
						let opacity = element.style.opacity;
						if (opacity === "") {
							opacity = "0";
						}
						const v = parseFloat(opacity) + 0.1;
						if (v >= 1) {
							element.style.opacity = "1";
							completedCallback();
						}
						else {
							element.style.opacity = `${v}`;
							fadeIn();
						}
					},
					25);
			};

			fadeIn();
		}

		private _resolveAndNavigate(pageKey: string, resolveCallback: (pageKey: string, page: WizardPage) => void, navigatedCallback?: (pageKey: string, page: WizardPage) => void) {

			// const page = this._resolvePage(pageKey);
			// if (!page) {
			// 	console.error(`unable to resolve page '${pageKey}'`);
			// 	return;
			// }

			// resolveCallback(pageKey, page);

			// this._showPage(page);


			this._fadeOutElement(this._pageContainer, () => {
				const page = this._resolvePage(pageKey);
				if (!page) {
					console.error(`unable to resolve page '${pageKey}'`);
					return;
				}

				resolveCallback(pageKey, page);

				this._showPage(page);

				this._fadeInElement(this._pageContainer, () => {
					if (typeof navigatedCallback === "function") {
						navigatedCallback(pageKey, page);
					}
				});
			});
		}

		private _resolvePage(pageKey: string) {
			let wizardPage: WizardPage;
			if (!(pageKey in this._wizardPages)) {
				const pageData = this._wizardData.pages[pageKey];
				wizardPage = new WizardPage(this, this._history);
				if (this._pageTemplate) {
					wizardPage.template = this._pageTemplate;
				}
				if (this._navButtonTemplate) {
					wizardPage.navButtonTemplate = this._navButtonTemplate;
				}
				wizardPage.pageData = pageData;
				wizardPage.htmlElement.addEventListener("navigate-back-request", this._onNavigateBackRequest.bind(this));
				wizardPage.htmlElement.addEventListener("navigate-next-request", this._onNavigateNextRequest.bind(this));
				wizardPage.htmlElement.addEventListener("navigate-request", this._onNavigateRequest.bind(this));
				wizardPage.htmlElement.addEventListener("completed-request", this._onCompletedRequest.bind(this));
				this._wizardPages[pageKey] = wizardPage;
			}
			else {
				wizardPage = this._wizardPages[pageKey];
			}
			return wizardPage;
		}

		private _showSplashPage() {

			const splashTemplate = WebComponent.resolveTemplate(this._splashTemplate);
			WebComponent.applyTemplate(splashTemplate, this._splashContainer);

			const contentContainer = this._splashContainer.querySelector(`[template-part="contentContainer"]`) as HTMLElement;
			contentContainer.innerText = this._wizardData.startText;

			this._splashButtonStart = new WizardNavButton();
			this._splashButtonStart.appearance = "text-only";
			this._splashButtonStart.text = this._wizardData.startButtonText;
			this._splashButtonStart.htmlElement.addEventListener("nav-click", this._onBeginClick.bind(this));
			if (this._navButtonTemplate) {
				this._splashButtonStart.template = this._navButtonTemplate;
			}
			const buttonContainer = this._splashContainer.querySelector(`[template-part="buttonContainer"]`) as HTMLElement;
			buttonContainer.appendChild(this._splashButtonStart.htmlElement);

			this._headerContainer.style.display = "none";
			this._pageContainer.style.display = "none";
			this._splashContainer.style.display = "block";
		}

		private _showPage(wizardPage: WizardPage) {

			this._headerContainer.style.display = null;
			this._pageContainer.style.display = null;
			this._splashContainer.style.display = "none";

			if (this._currentPage) {
				this._currentPage.htmlElement.remove();
			}
			this._currentPage = wizardPage;
			this._pageContainer.appendChild(wizardPage.htmlElement);
			this._setActiveStepGroup(wizardPage.pageData.groupName);
		}

		private _ensurGroupHeaderIsVisible() {
			const groupOffsetAndWidth = this._currentGroup.htmlElement.offsetLeft + this._currentGroup.htmlElement.offsetWidth;
			if (groupOffsetAndWidth > this._headerContainer.offsetWidth) {
				const scrollOffset = this._headerContainer.scrollWidth - this._headerContainer.offsetWidth;
				if (scrollOffset > 0) {
					this._headerContainer.scrollLeft = scrollOffset;
				}
			}
		}

		private _ensureGroupHeaderIsVisibleOrCentered() {
			const headerWidth = this._headerContainer.scrollWidth;
			if(headerWidth > this._headerWrapper.offsetWidth) {
				// centered
				const groupHeaderOffset = this._currentGroup.htmlElement.offsetLeft;
				const groupHeaderWidth = this._currentGroup.htmlElement.offsetWidth;
				const left = (this._headerWrapper.offsetWidth * 0.5) - (groupHeaderWidth * 0.5) - groupHeaderOffset;
				this._headerContainer.style.left = left + "px";
			}
			else {
				// normal
				this._headerContainer.style.left = "0";
			}
		}

		private _onBeginClick(e: CustomEvent) {

			this._fadeOutElement(this._splashContainer, () => this._splashContainer.style.display = "none");

			this._resolveAndNavigate(
				this._wizardData.startPage,
				(pageKey, page) => {
					this._history.pushAndGoTo(pageKey);
				},
				(pageKey, page) => {
					this._updateGropuHeadersState(page.pageData);
				});
		}

		private _onGroupClick(e: CustomEvent) {
			//alert(`index: ${e.detail.index}, groupName: ${e.detail.groupName}, target: ${e.detail.target}`);

			this._resolveAndNavigate(
				e.detail.target,
				(pageKey, page) => {
					this._history.pushAndGoTo(pageKey);
				},
				(pageKey, page) => {
					this._updateGropuHeadersState(page.pageData);
				});
		}

		private _onCompletedRequest(e: CustomEvent) {

			console.dir(e.detail.stepValues);
			for (const k of Object.keys(e.detail.stepValues)) {
				const value = e.detail.stepValues[k];
				this._resultData[k] = value;
			}

			console.log(this._resultData);

			this._triggerWizardCompletedEvent();
		}

		private _onNavigateBackRequest(e: Event) {
			if (this._history.canGoBack) {
				this._triggerBeginNavigateEvent(this._history.previousItem.value);
				this._resolveAndNavigate(
					this._history.previousItem.value,
					(pageKey, page) => {
						this._history.goBack();
						this._triggerEndNavigateEvent(pageKey);
					},
					(pageKey, page) => {
						this._updateGropuHeadersState(page.pageData);
					});
			}
		}

		private _onNavigateNextRequest(e: Event) {
			if (this._history.canGoNext) {
				this._triggerBeginNavigateEvent(this._history.nextItem.value);
				this._resolveAndNavigate(
					this._history.nextItem.value,
					(pageKey, page) => {
						this._history.goNext();
					},
					(pageKey, page) => {
						this._updateGropuHeadersState(page.pageData);
						this._triggerEndNavigateEvent(pageKey);
					});
			}
		}

		private _onNavigateRequest(e: CustomEvent) {

			this._triggerBeginNavigateEvent(e.detail.pageKey);

			console.dir(e.detail.stepValues);
			for (const k of Object.keys(e.detail.stepValues)) {
				const value = e.detail.stepValues[k];
				this._resultData[k] = value;
			}

			console.log(this._resultData);

			this._resolveAndNavigate(
				e.detail.pageKey,
				(pageKey, page) => {
					this._history.pushAndGoTo(pageKey);
				},
				(pageKey, page) => {
					this._updateGropuHeadersState(page.pageData);
					this._triggerEndNavigateEvent(pageKey);
				});
		}

		private _triggerWizardCompletedEvent() {
			this.htmlElement.dispatchEvent(new CustomEvent("wizard-completed", {
				detail: {
					sender: this,
					result: this._resultData
				}
			}));
		}

		private _triggerBeginNavigateEvent(pageKey: string) {
			this.htmlElement.dispatchEvent(new CustomEvent("begin-navigate", {
				detail: {
					sender: this,
					pageKey: pageKey
				}
			}));
		}

		private _triggerEndNavigateEvent(pageKey: string) {
			this.htmlElement.dispatchEvent(new CustomEvent("end-navigate", {
				detail: {
					sender: this,
					pageKey: pageKey
				}
			}));
		}

		private _updateGropuHeadersState(currentPageData: WizardPageData) {
			let groupIndex = -1;
			for (const header of this._groupHeaders) {
				groupIndex++;
				if (header.groupName === currentPageData.groupName) {
					break;
				}
			}
			if (groupIndex >= 0) {
				for (let i = 0; i < this._groupHeaders.length; i++) {
					if ( i === groupIndex) {
						this._currentGroup = this._groupHeaders[i];
					}
					if (i > groupIndex) {
						this._groupHeaders[i].isVisited = false;
					}
				}
			}

			//this._ensurGroupHeaderIsVisible();
			this._ensureGroupHeaderIsVisibleOrCentered();
		}

		private _resolvePaths() {
			// TODO scorrere le pagine e costruire tutti i percorsi possibili
			// quindi caricare il primo come header, in base a startPage
			const resolver = new WizardPathResolver(this._wizardData);
			this._groupNamePaths = resolver.resolveGroupNamePaths();
			this._currentGroupNamePath = this._groupNamePaths[0];
			this._buildWizardHeader(this._currentGroupNamePath);
		}

		private _setActiveStepGroup(groupName: string) {

			//debugger;

			let groupHeadersStates: DynamicObject = null;

			if (this._currentGroupNamePath.filter(x => x[0] === groupName).length === 0) {
				const newPathGroup = this._groupNamePaths.filter(x => x.filter(y => y[0] === groupName).length > 0)[0];
				if (!newPathGroup) {
					throw new Error("invalid result");
				}

				// save groupHeaderStates
				groupHeadersStates = {};
				for (const header of this._groupHeaders) {
					groupHeadersStates[header.groupName] = {
						isActive: header.isActive,
						isVisited: header.isVisited
					};
				}

				this._buildWizardHeader(newPathGroup);
			}

			for (const groupHeader of this._groupHeaders) {

				if (groupHeader.groupName === groupName) {
					groupHeader.isActive = true; // isActive;
					groupHeader.isVisited = true; // isVisited;
					this._currentGroup = groupHeader;
				} else {

					if (groupHeadersStates && groupHeader.groupName in groupHeadersStates) {
						const state = groupHeadersStates[groupHeader.groupName];
						groupHeader.isVisited = state.isVisited;
					}
					groupHeader.isActive = false;
				}
			}
		}

		private _updatePagesTemplate() {
			if (this._pageTemplate && this._wizardPages) {
				for (const k of Object.keys(this._wizardPages)) {
					const page = this._wizardPages[k];
					page.template = this._pageTemplate;
				}
			}
		}

		private _updatePageNavButtonsTemplate() {
			if (this._navButtonTemplate) {
				if (this._splashButtonStart) {
					this._splashButtonStart.template = this._navButtonTemplate;
				}
				if (this._wizardPages) {
					for (const k of Object.keys(this._wizardPages)) {
						const page = this._wizardPages[k];
						page.navButtonTemplate = this._navButtonTemplate;
					}
				}
			}
		}

		private _updateGroupHeadersTemplate() {
			if (this._groupHeaderTemplate && this._groupHeaders) {
				for (const header of this._groupHeaders) {
					header.template = this._groupHeaderTemplate;
				}
			}
		}

		private _updateSplashTemplate() {
			if (this._wizardData) {
				this._showSplashPage();
			}
		}


		public get wizardData() { return this._wizardData; }
		public set wizardData(v: WizardData) {
			this._wizardData = v;
			this._loadData();
		}

		public get splashTemplate() { return this._splashTemplate; }
		public set splashTemplate(v: TemplateSource) {
			if (this._splashTemplate !== v) {
				this._splashTemplate = v;
				this._updateSplashTemplate();
			}
		}

		public get pageTemplate() { return this._pageTemplate; }
		public set pageTemplate(v: TemplateSource) {
			if (this._pageTemplate !== v) {
				this._pageTemplate = v;
				this._updatePagesTemplate();
			}
		}

		public get navButtonTemplate() { return this._navButtonTemplate; }
		public set navButtonTemplate(v: TemplateSource) {
			if (this._navButtonTemplate !== v) {
				this._navButtonTemplate = v;
				this._updatePageNavButtonsTemplate();
			}
		}

		public get groupHeaderTemplate() { return this._groupHeaderTemplate; }
		public set groupHeaderTemplate(v: TemplateSource) {
			if (this._groupHeaderTemplate !== v) {
				this._groupHeaderTemplate = v;
				this._updateGroupHeadersTemplate();
			}
		}
	}
}